module.exports = __webpack_public_path__ + "img/mada.25628939.png";